import { Pipe, PipeTransform } from '@angular/core'
import { DatePipe } from '@angular/common'

@Pipe({
  name: 'dateFormatPipe',
})
export class DateFormatPipe implements PipeTransform {
  transform(value: string) {
    var datePipe = new DatePipe('en-US')
    try {
      value = datePipe.transform(value, 'dd-MM-yyyy')
      return value
    } catch (exp) {
      try {
        let myVar = JSON.parse(value)
        let myDate = new Date(myVar.year, myVar.month, myVar.day)
        value = datePipe.transform(myDate, 'dd-MM-yyyy')
        return value
      } catch (error) {
        return value
      }
    }
  }
}
